import { render, staticRenderFns } from "./informacion_departamentos_prolipa.vue?vue&type=template&id=136bca48&scoped=true"
import script from "./informacion_departamentos_prolipa.vue?vue&type=script&lang=js"
export * from "./informacion_departamentos_prolipa.vue?vue&type=script&lang=js"
import style0 from "./informacion_departamentos_prolipa.vue?vue&type=style&index=0&id=136bca48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136bca48",
  null
  
)

export default component.exports